export const suppressPhrases = [
  'chrome-extension://',
  'Network Error',
  'Request Aborted',
  'Request aborted',
  'AbortError',
  'NS_ERROR_FILE_CORRUPTED',
  'Object captured as promise rejection with keys',
  '_AutofillCallbackHandler',
  'Object.hasOwn',
  'clarity.ms',
  'Event `CustomEvent` (type=unhandledrejection) captured as promise rejection',
]

export const beforeSend = (event) => {
  const eventString = JSON.stringify(event)

  if (suppressPhrases.some((phrase) => eventString.includes(phrase))) {
    return null
  }

  // Note: temporarily disable the manual parsing of the event object, bring
  // back if the string search above doesn't work.
  // if (event.exception && event.exception.values && event.exception.values.length > 0) {
  //   for (let i = 0; i < event.exception.values.length; i++) {
  //     const value = event.exception.values[i]
  //
  //     for (let j = 0; j < suppressPhrases.length; j++) {
  //       const phrase = suppressPhrases[j]
  //
  //       if (value.value?.includes(phrase)) {
  //         return null
  //       }
  //
  //       if (value.type?.includes(phrase)) {
  //         return null
  //       }
  //     }
  //   }
  // }

  return event
}

export const beforeSendSpan = () => {
  // temporarily disable spans
  return null
}

export default {
  // Define all sentry configuration here that both vue and blade contexts
  // should share
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  beforeSend,
  beforeSendSpan,
  allowUrls: [/https:\/\/liveplatforms-[^.]+\.b-cdn\.net\//],
}
